import React, { useState } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useSaveGame, useUpdateGame } from "@seabrookstudios/pitch2table";
import { useSnackbar } from "notistack";
import { importNestifyzGame } from "./importNestifyzGame";

/**
 * @param {object} props
 * @param {import("../nestifyz/parseExport").NestiFyzGame} props.NestiFyzGame
 * @param {(gameId: import("@seabrookstudios/types").GameId) => void} props.onCreate
 */
export const NestiFyzImportGameButton = ({ NestiFyzGame, onCreate }) => {
  const { enqueueSnackbar } = useSnackbar();
  const saveGame = useSaveGame();
  const updateGame = useUpdateGame();
  const [isImporting, setIsImporting] = useState(false);

  const onImport = async () => {
    if (!NestiFyzGame.id || isImporting) {
      return;
    }

    setIsImporting(true);

    try {
      const { gameId } = await importNestifyzGame(NestiFyzGame, {
        saveGame: saveGame.mutateAsync.bind(saveGame),
        updateGame: updateGame.mutateAsync.bind(updateGame),
      });

      onCreate(gameId);
    } catch {
      enqueueSnackbar(`Failed to import ${NestiFyzGame.title || "game"}. Please try again.`, { variant: "error" });
    } finally {
      setIsImporting(false);
    }
  };

  return (
    <Stack alignItems="flex-end" spacing={1} sx={{ minWidth: 280 }}>
      <Button
        variant="outlined"
        size="small"
        disabled={isImporting || saveGame.isPending || updateGame.isPending || !NestiFyzGame.id}
        onClick={onImport}
      >
        Import
      </Button>
    </Stack>
  );
};
